import { render, staticRenderFns } from "./infoServices.vue?vue&type=template&id=79a129e2&scoped=true&"
import script from "./infoServices.vue?vue&type=script&lang=js&"
export * from "./infoServices.vue?vue&type=script&lang=js&"
import style0 from "./infoServices.vue?vue&type=style&index=0&id=79a129e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a129e2",
  null
  
)

export default component.exports